import { useState } from 'react'

import { TabContainer } from '../styles'
import { AttendeeQuestions } from './attendee_questions'
import { AttendeeSelector } from './attendee_selector'
import { RoutingQuestions } from './routing_questions'

const GroupEvent = ({ selectedEvent }) => {
  const [selectedInvitee, setSelectedInvitee] = useState({})

  return (
    <>
      <AttendeeSelector selectedEvent={selectedEvent} onSelect={setSelectedInvitee} />
      <RoutingQuestions questions={selectedInvitee?.formBuilderSubmission?.questions} />
      <AttendeeQuestions invitee={selectedInvitee} questions={selectedInvitee.eventFields} />
    </>
  )
}

const SoloEvent = ({ selectedEvent }) => (
  <>
    <RoutingQuestions questions={selectedEvent.invitee?.formBuilderSubmission?.questions} />
    <AttendeeQuestions invitee={selectedEvent?.invitee} questions={selectedEvent?.invitee?.eventFields} />
  </>
)

export const QuestionsTab = ({ selectedEvent }) => {
  const isGroupEvent = selectedEvent.eventType.kind === 'group'

  return (
    <TabContainer>
      {!isGroupEvent && <SoloEvent selectedEvent={selectedEvent} />}
      {isGroupEvent && <GroupEvent selectedEvent={selectedEvent} />}
    </TabContainer>
  )
}
